
import "bootstrap/dist/css/bootstrap.min.css";

const Header = () => {
  return (
    <header className="header">
      <h3>SISTEMA DE GESTION DE CITAS</h3>
      {/*<button className="btn btn-primary">Nueva Cita</button>*/}
    </header>
  );
};

export default Header;